import { createGlobalStyle } from 'styled-components';
export const GlobalStyles = createGlobalStyle`
  .deckard-custom-fee-description th, .deckard-custom-fee-description td {
    padding: 5px;
  }
`

